import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container flex justify-around items-center h-24 w-1/2" }

import { useI18n } from 'vue-i18n';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeLanguage',
  setup(__props) {

const { locale } = useI18n();

const changeLang = (lang: string) => {
  //持久化，避免刷新页面后重置中英文
  // locale.value = lang;
  // window.location.reload();
  // changeLanguage(lang);

  var url = window.location.origin
    .replace('en.', lang + '.')
    .replace('www.', lang + '.');

  if (
    window.location.pathname.includes('product') ||
    window.location.pathname.includes('solution') ||
    window.location.pathname.includes('news/')
  ) {
    window.location.href = url;
  } else {
    url += window.location.pathname;
  }

  if (window.location.search) {
    url += '?' + window.location.search;
  }
  if (window.location.hash) {
    url += '#' + window.location.hash;
  }
  window.location.href = url;
};

const currentLang = computed(() =>
  locale.value === 'en-US' ? 'ChangeLanguage.en' : 'ChangeLanguage.zh'
);

return (_ctx: any,_cache: any) => {
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    label: _ctx.$t(currentLang.value),
    flat: "",
    dense: "",
    round: "",
    "content-class": "left-0! right-0! max-w-none! w-full flex justify-center"
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        _createElementVNode("li", {
          class: _normalizeClass(`text-${
          _unref(locale) === 'zh-Hans' ? 'green' : 'gray'
        }-600 text-xl py-3`)
        }, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeLang('www')))
          }, _toDisplayString(_ctx.$t('ChangeLanguage.zh')), 1)
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(`text-${
          _unref(locale) === 'en-US' ? 'green' : 'gray'
        }-600 text-xl py-3`)
        }, [
          _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeLang('en')))
          }, _toDisplayString(_ctx.$t('ChangeLanguage.en')), 1)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})